import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md', 
  className = '',
  disabled = false,
  type = 'button',
  ...props 
}) => {
  const baseClasses = 'font-medium transition-colors duration-200 rounded focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variants = {
    primary: 'bg-bmb-text text-white hover:bg-primary-700 focus:ring-bmb-text',
    secondary: 'bg-bmb-accent text-bmb-text hover:bg-gray-200 focus:ring-gray-300',
    outline: 'border border-bmb-text text-bmb-text hover:bg-bmb-text hover:text-white focus:ring-bmb-text',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
  };

  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : '';

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;